import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const WhoItsFor = () => {
  const industries = [
    { icon: FiIcons.FiTool, title: "HVAC & Plumbing Companies" },
    { icon: FiIcons.FiHome, title: "Roofing & Remodeling Contractors" },
    { icon: FiIcons.FiZap, title: "Electrical & Handyman Services" },
    { icon: FiIcons.FiShield, title: "Pest Control & Lawn Care Companies" },
    { icon: FiIcons.FiActivity, title: "Cleaning & Restoration Services" },
    { icon: FiIcons.FiCalendar, title: "Any Home Service Business" }
  ];

  return (
    <section className="py-24 bg-navy-light border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-anton uppercase tracking-wide text-white mb-6">
            Built For Businesses That <span className="text-gold">Live Or Die By Appointments</span>
          </h2>
          <p className="text-xl text-gray-400 font-medium max-w-3xl mx-auto">
            If your website has a "Schedule Service" or "Book Now" button, AgentOnDemand turns it into a source of booked jobs and real leads — not just clicks.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((item, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="bg-navy p-8 rounded-xl border border-white/10 hover:border-gold/50 transition-colors group flex flex-col items-center justify-center"
            >
              <div className="w-16 h-16 rounded-full bg-white/5 group-hover:bg-gold/10 flex items-center justify-center mb-6 transition-colors">
                <SafeIcon icon={item.icon} className="text-3xl text-gray-300 group-hover:text-gold transition-colors" />
              </div>
              <h4 className="text-xl font-anton uppercase tracking-wide text-white text-center">
                {item.title}
              </h4>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhoItsFor;